<div class="composable-modal">
  <lt-icon name="fa-sharp-solid-times" data-testid="composable-modal-close-btn" (click)="onCancel()"></lt-icon>

  <div class="composable-header" [class.error-theme]="header().theme === 'error'">
    <div class="icon">
      @if (header().icon; as icon) {
        <lt-icon [name]="icon" class="{{ iconClasses() }}" />
      }
    </div>

    <ng-container
      *ngTemplateOutlet="
        contentRenderer;
        context: {
          wrapperClass: 'title',
          innerContent: header().innerTitle,
          translationKey: header().titleKey,
          translationParams: header().titleParams
        }
      "
    />
  </div>

  <div class="composable-body">
    <ng-container
      *ngTemplateOutlet="
        contentRenderer;
        context: {
          wrapperClass: 'description',
          innerContent: detail().innerDetails,
          translationKey: detail().detailsKey,
          translationParams: detail().detailsParams
        }
      "
    />

    @if (detail().innerComponent) {
      <ng-container
        #innerComponentOutlet="ngComponentOutlet"
        [ngComponentOutlet]="detail().innerComponent!"
        [ngComponentOutletInputs]="detail().componentInputs"
      />
    }

    @if (detail().innerCautionMessage || detail().cautionMessageKey) {
      <ng-container
        *ngTemplateOutlet="
          contentRenderer;
          context: {
            wrapperClass: 'caution-message',
            innerContent: detail().innerCautionMessage,
            translationKey: detail().cautionMessageKey
          }
        "
      />
    }
  </div>

  <div class="composable-actions {{ buttons().layout }}-layout">
    @if (buttons().confirmKey; as confirmKey) {
      <button
        class="btn primary-btn"
        data-testid="composable-modal-confirm-btn"
        [class.lt-btn-secondary]="buttons().layout === ButtonLayout.INLINE"
        (click)="onConfirm()"
      >
        {{ confirmKey | ltTranslate }}
      </button>
    }
    @if (buttons().cancelKey; as cancelKey) {
      <button class="btn btn-cancel" data-testid="composable-modal-cancel-btn" (click)="onCancel()">
        {{ cancelKey | ltTranslate }}
      </button>
    }
  </div>
</div>

<ng-template
  #contentRenderer
  let-wrapperClass="wrapperClass"
  let-innerContent="innerContent"
  let-translationKey="translationKey"
  let-translationParams="translationParams"
>
  @if (innerContent) {
    <div class="{{ wrapperClass }}" [innerHTML]="innerContent | ltTranslate: translationParams"></div>
  } @else if (translationKey) {
    <div class="{{ wrapperClass }}">
      {{ translationKey | ltTranslate: translationParams }}
    </div>
  }
</ng-template>
